<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="nav flex-column px-0 pb-1 pt-0">
          <router-link class="nav-link text-muted px-0 pb-1 pt-0" to="/" exact>
            <fa-icon :icon="['fal', 'newspaper']" class="mr-2"></fa-icon>
            Das Neueste
          </router-link>
          <router-link class="nav-link text-muted px-0 pb-1 pt-0" to="/top">
            <fa-icon :icon="['fal', 'heart-rate']" class="mr-2"></fa-icon>
            Top Stories
          </router-link>
          <router-link class="nav-link text-muted px-0 pb-1 pt-0" to="/favorites">
            <fa-icon :icon="['fal', 'bookmark']" class="mr-2"></fa-icon>
            Mein Merkzettel
          </router-link>
        </div>

        <hr>

        <h6 class="font-weight-bold">
          Quellen
        </h6>

        <ul class="list-unstyled" v-if="sources.length > 0">
          <li class="mb-1">
            <router-link class="text-muted" to="/" exact>
              <span class="mr-2">
                <fa-icon :icon="['fal', 'circle']"></fa-icon>
                <fa-icon :icon="['fal', 'dot-circle']"></fa-icon>
              </span>
              Alle Quellen
            </router-link>
          </li>

          <li class="mb-1" v-for="source in sources" :key="source.id">
            <router-link class="text-muted" :to="'/sources/' + source.id">
              <span class="mr-2">
                <fa-icon :icon="['fal', 'circle']"></fa-icon>
                <fa-icon :icon="['fal', 'dot-circle']"></fa-icon>
              </span>

              {{ source.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <ad :zone="113" class="mt-3 s300x250"></ad>

    <div class="text-center">
      <a href="https://sibforms.com/serve/MUIFAKSnvgQpfsnGbLvHa1CX-1gntEP4mv5fH7MQD1Rj7-YdrTRbzkxYvyalZ6LbCzxACQY6XNmc-XZhm_M4kpPZW6aIVOTWaZ3BzxeYKImC9wG3wqNXK0qwIuEK35x1HRH_1sok7w0C9U8lCgZu5ndP7SkNqyNnDEVJ8JjBP8huD1fdLHgwoM5otUPrvl37sHzd4vKLL4XPQRDT" class="btn btn-outline-success mt-3">
        Jetzt Newsletter abonnieren
      </a>
    </div>
  </div>
</template>

<script>
  import Ad from '@/vues/helpers/ad.vue';

  export default {
    name: 'Sidebar-Left',
    components: { Ad },
    props: {
      sources: {
        type: Array,
        default () {
          return [];
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  a {
    &.active.text-muted {
      color: #FF5A4B !important;
    }

    &:hover {
      text-decoration: none;
      color: #333 !important;
    }
  }

  li > a {
    svg {
      display: none !important;

      &:nth-of-type(1) {
        display: inline-block !important;
      }
    }

    &.active {
      svg {
        &:nth-of-type(1) {
          display: none !important;
        }

        &:nth-of-type(2) {
          display: inline-block !important;
        }
      }
    }
  }
</style>
